/**
 * @file Skeleton atom — loading placeholder family.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Skeleton
 */
export { Skeleton, SkeletonText } from "@/components/ui/skeleton";
